import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClientInfo } from '../../actions';
import useQuery from './useQuery';

const UseUserDate = () => {
  const { tipo, modelo, color, version, anio } = useParams();
  const query = useQuery();

  const { gometa } = useSelector(state => ({
    gometa: state?.personalization?.gometa
  }));

  useEffect(() => {
    saveHubInformationIfAvailable();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dispatch = useDispatch();

  const saveHubInformationIfAvailable = () => {
    const dni = query.get('dni');
    if (!dni) {
      return;
    }

    saveUserData({ 
      email: query.get('email'), 
      name : query.get('name'), 
      phone: query.get('phone'), 
      lastName: query.get('lastname'), 
      typeId: query.get('dni_type'), 
      id: dni,
      profession: '',
      address: '',
      typeContract: '',
      typeContact: ''
    });
  };
  
  const getClientInfoRequest = (id, callback) => {
    dispatch(getClientInfo(
      tipo,
      modelo,
      version,
      anio,
      color,
      id,
      callback
    ));
  }
  
  const [ userData, setUserData ] = useState(JSON.parse(localStorage.getItem('user') || "{}"));

  const saveUserData = ({ email, name, phone, lastName, typeId, id, profession, address, typeContract, typeContact}) => {
    localStorage.setItem('user', JSON.stringify({
      email, name, phone, lastName, typeId, id, profession, address, typeContract, typeContact
    }));
    setUserData(JSON.parse(localStorage.getItem('user') || "{}"));
  } 

  const saveMinimalUserData = ({ email, name, phone, id, lastName}) => {
    localStorage.setItem('user', JSON.stringify({
      ...userData,
      email, name, phone, id, lastName
    }));
    setUserData(JSON.parse(localStorage.getItem('user') || "{}"));
  } 

  
  return { userData, saveUserData, getClientInfoRequest, gometa, saveHubInformationIfAvailable, saveMinimalUserData };
};

export default UseUserDate;